import { useMemo } from 'react';
import { useScene } from 'src/hooks/useScene';
import { useUiStateStore } from 'src/stores/uiStateStore';
import { Connector } from './Connector';

interface Props {
  connectors: ReturnType<typeof useScene>['connectors']; // This matches the actual interface
}

export const Connectors = ({ connectors }: Props) => {
  const itemControls = useUiStateStore((state) => state.itemControls);
  const mode = useUiStateStore((state) => state.mode);
  const selectedConnectorId = useMemo(() => {
    if (mode.type === 'CONNECTOR') return mode.id;
    if (itemControls?.type === 'CONNECTOR') return itemControls.id;
    if (itemControls?.type === 'CONNECTOR_ANCHOR') {
      return connectors.find((connector) =>
        connector.anchors.some((anchor) => anchor.id === itemControls.id)
      )?.id ?? null;
    }
    return null;
  }, [mode, itemControls, connectors]);

  return (
    <>
      {/* Render connector lines */}
      {[...connectors].reverse().map((connector) => {
        return (
          <Connector
            key={connector.id}
            connector={connector}
            isSelected={selectedConnectorId === connector.id}
          />
        );
      })}
    </>
  );
};
